import React, { useEffect, useRef, useState } from "react";
import TitleBar from "../../components/common-components/TitleBar";
import {
  Box,
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  Modal,
  styled,
  TableCell,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  ModalWrapper,
} from "../../components/style/modalStyleLarge";
import CustomButton from "../../components/common-components/CustomButton";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import profileImg from "../../assets/Images/dummyprofile.jpeg";
import AccountStatusButton from "../../components/common-components/AccountStatusButton";
import {
  ActiveClientIcon,
  CrossIcon,
  EmailIconDetail,
  LocationIcon,
  PhoneIconDetail,
} from "../../assets/Icon/ModalIcon";
import {
  assignTool,
  ClientDetailData,
  deactivateCleintTool,
  getallTools,
  getClientsToolsList,
} from "../../stores/clients";
import { useAppDispatch } from "../../stores/store";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { setToast } from "../../stores/toast/toastslice";
import CustomTable from "../../components/common-components/CustomTable";
import { Formik } from "formik";
import dayjs, { Dayjs } from "dayjs";
import { DownArrowIcon } from "../../assets/Icon/ArrowIcon";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { RemoveCircle } from "@mui/icons-material";
import CommonPagination from "../../components/common-components/CommonPagination";
import { BackPageIcon } from "../../assets/Icon/dashboredIcon";

const ClientDetail = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const { clientDetail, detailLoading } = useSelector(
    (store: any) => store.clients,
  );

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [pageNo, setPageNo] = useState(1);
  const [limit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [data, setData] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const filterRef = useRef<HTMLDivElement>(null);
  const filterCategoryRef = useRef<HTMLDivElement>(null);
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterCategoryValue, setFilterCategoryValue] = useState("");
  const [openFilterCategory, setOpenFilterCategory] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [toolId, setToolId] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [selecteToolType, setSelectedToolType] = useState(0);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([
    {
      name: "ITIN",
      id: 1,
    },
    {
      name: "LLC",
      id: 2,
    },
    {
      name: "Expedite ITIN",
      id: 3,
    },
    {
      name: "Tax Filing",
      id: 3,
    },
    { name: "Invoicing", id: 4 },
    { name: "Operating Agreement", id: 5 },
    { name: "Bookkeeper", id: 6 },
  ]);

  useEffect(() => {
    dispatch<any>(ClientDetailData(id));
    dispatch<any>(getallTools()).then((res: any) => {
      setCategories(res?.payload?.data?.tools);
    });
    dispatch<any>(
      getClientsToolsList({ id: id?.toString() || "", offset: pageNo, limit }),
    ).then((res: any) => {
      setData(res?.payload?.data);
      setTotalRecords(res?.payload?.total_records);
    });
  }, [dispatch, id, pageNo, loading, isFilterApplied]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // ✅ Ignore clicks inside DatePicker popup
      if (target.closest(".MuiPickersPopper-root")) {
        return;
      }

      // ✅ Ignore clicks inside MUI Menu (Category dropdown)
      if (target.closest(".MuiPopover-root")) {
        return;
      }

      // ✅ Close only if click is outside the filter container
      if (filterRef.current && !filterRef.current.contains(target)) {
        setOpenFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDeactivateTool = async () => {
    setLoading(true);
    await dispatch<any>(
      deactivateCleintTool({
        id: selectedId,
        tool_type: selecteToolType,
      }),
    )
      .then((res: any) => {
        if (res?.payload?.code === 200) {
          dispatch<any>(
            setToast({
              message: res?.payload?.message,
              type: "success",
              title: "Success",
            }),
          );
        } else {
          dispatch<any>(
            setToast({
              message: res?.payload?.message,
              type: "error",
              title: "Error",
            }),
          );
        }
      })
      .finally(() => {
        setLoading(false);
        setIsModalOpen(false);
      });
  };

  const handlePageChange = (newPage: number) => {
    setPageNo(newPage);
  };

  return (
    <>
      <Box
        onClick={() =>
          navigate("/admin-clients", { state: { pageNo: state?.pageNo } })
        }
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "2px",
          cursor: "pointer",
          width: "fit-content",
          marginBottom: "20px",
        }}
      >
        <BackPageIcon />
        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "22px",
            letterSpacing: "-0.7%",
            color: "#6C6F71",
          }}
        >
          {"Back"}
        </Typography>
      </Box>

      <TitleBar title="Client Details" />
      {detailLoading === "loading" ? (
        <ListLoadingNew />
      ) : (
        <StyledBox>
          <Box>
            <ProfileImage src={profileImg} alt="client-img" />
          </Box>

          <DetailsContainer>
            <Row>
              <NameText>
                {`${clientDetail?.first_name} ${clientDetail?.last_name}` ||
                  "N/A"}
              </NameText>
              <AccountStatusButton
                rowstatus={clientDetail?.is_active ?? false}
                agentId={clientDetail?.id ?? 0}
              />
            </Row>

            <Row>
              <DividerBlock>
                <LabelText>Email Address</LabelText>
                <Row>
                  <EmailIconDetail />
                  <ValueText>{clientDetail?.email || "N/A"}</ValueText>
                </Row>
              </DividerBlock>

              <Box>
                <LabelText>Phone Number</LabelText>
                <Row>
                  <PhoneIconDetail />
                  <ValueText>{clientDetail?.phone || "N/A"}</ValueText>
                </Row>
              </Box>
            </Row>

            <Box>
              <LabelText>Address</LabelText>
              <Row>
                <LocationIcon />
                <ValueText>{clientDetail?.address || "N/A"}</ValueText>
              </Row>
            </Box>
          </DetailsContainer>
        </StyledBox>
      )}
      <div
        style={{
          display: isMobile ? "grid" : "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          padding: 20,
          marginTop: 20,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <div
          style={{
            fontSize: "20px",
            fontWeight: 600,
          }}
        >
          Tools and Services
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
          <div ref={filterRef} style={{ position: "relative" }}>
            <Button
              style={{
                border: "1px solid #EAF1FA",
                borderRadius: "8px",
                height: "40px",
                padding: 15,
                color: "#6C6F71",
                fontSize: "14px",
                fontWeight: 600,
                gap: 10,
              }}
              onClick={() => {
                setOpenFilter(!openFilter);
              }}
            >
              <AssignmentOutlinedIcon fontSize="small" />
              Assign Tool
            </Button>

            {openFilter && (
              <div
                style={{
                  position: "absolute",
                  bottom: window.innerHeight < 760 ? 25 : "auto",
                  marginTop: 10,
                  backgroundColor: "white",
                  borderRadius: "8px",
                  width: isMobile ? "240px" : "400px",
                  right: isMobile ? "" : "0px",
                  zIndex: 1000,
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  marginBottom: 20,
                }}
              >
                <div>
                  <p
                    style={{
                      padding: 10,
                      paddingTop: 16,
                      paddingLeft: 16,
                      borderBottom: "1px solid #EDF2F6",
                      color: "#01060B",
                      fontSize: "16px",
                      fontWeight: 500,
                    }}
                  >
                    Assign Tool
                  </p>
                  <Formik
                    initialValues={{}}
                    onSubmit={() => {}}
                    validateOnChange={true}
                  >
                    {() => (
                      <div style={{ padding: "0px 20px 20px 10px" }}>
                        {/**Category filter */}
                        <div
                          ref={filterCategoryRef}
                          style={{ position: "relative", marginBottom: 10 }}
                        >
                          <div
                            style={{
                              fontWeight: 500,
                              color: "#2C3034",
                              fontSize: "16px",
                              marginBottom: 5,
                              display: "block",
                              marginTop: 14,
                            }}
                          >
                            Tools
                          </div>
                          {/* Red dot indicator when filter is applied */}
                          <Button
                            style={{
                              border: "0.5px solid #EAF1FA",
                              borderRadius: "8px",
                              height: "40px",
                              padding: 15,
                              color: "#97999B",
                              fontSize: "16px",
                              fontWeight: 500,
                              width: "100%",
                            }}
                            onClick={() => {
                              setOpenFilterCategory(!openFilterCategory);
                            }}
                          >
                            {filterCategoryValue?.length ? (
                              <p
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                  color: "black",
                                  fontWeight: 400,
                                }}
                              >
                                {filterCategoryValue?.length > 30
                                  ? `${filterCategoryValue?.slice(0, 30)}...`
                                  : filterCategoryValue}
                                <DownArrowIcon />
                              </p>
                            ) : (
                              <p
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                {" "}
                                Select Tools
                                <DownArrowIcon />
                              </p>
                            )}
                          </Button>
                          {openFilterCategory && (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 10,
                                backgroundColor: "white",
                                borderRadius: "8px",
                                width: "480px",
                                right: isMobile ? "" : "0px",
                                zIndex: 1000,
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                marginBottom: 20,
                              }}
                            >
                              {openFilterCategory && (
                                <Menu
                                  open={openFilterCategory}
                                  anchorEl={filterCategoryRef.current}
                                  onClose={() => setOpenFilterCategory(false)}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  PaperProps={{
                                    style: {
                                      height:
                                        categories?.length > 1 ? "160px" : "",
                                      borderRadius: "8px",
                                      marginTop: 0,
                                      width: "400px",
                                      boxShadow:
                                        "0px 2px 4px rgba(0, 0, 0, 0.2)",
                                    },
                                  }}
                                >
                                  {categories?.map((item: any, idx) => (
                                    <MenuItem
                                      key={item?.id}
                                      onClick={() => {
                                        console.log("Filter by year:", item);
                                        setOpenFilterCategory(false);
                                        setFilterCategoryValue(item?.tool_name);
                                        setToolId(item?.tool_id);
                                      }}
                                      sx={{
                                        borderRadius: "6px",
                                        "&:hover": {
                                          backgroundColor: "#A7C7EA66", // light blue hover
                                          color: "#1D538F",
                                          borderRadius: 0,
                                        },
                                        borderBottom:
                                          idx <= categories?.length - 2
                                            ? "1px solid #EDF2F6"
                                            : "",
                                        color: "#6C6F71",
                                        fontWeight: 500,
                                        fontSize: "16px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "100%",
                                          paddingTop: 2,
                                          paddingBottom: 2,
                                        }}
                                      >
                                        {item?.tool_name?.length > 40
                                          ? `${item?.tool_name?.slice(0, 40)}...`
                                          : item?.tool_name}
                                      </div>
                                    </MenuItem>
                                  ))}
                                </Menu>
                              )}
                            </div>
                          )}
                        </div>
                        {/**Dates */}
                        {(toolId === 6 || toolId === 4) && (
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="en-gb"
                          >
                            <Box>
                              <div>
                                <label
                                  style={{
                                    fontWeight: 500,
                                    color: "#2C3034",
                                    fontSize: "16px",
                                    marginBottom: 5,
                                    display: "block",
                                  }}
                                >
                                  Trial End date
                                </label>
                                <DatePicker
                                  format="DD/MM/YYYY"
                                  value={startDate}
                                  //maxDate={dayjs().startOf("day")} // ⬅ Disable future dates
                                  minDate={dayjs().startOf("day")}
                                  onChange={(val) => {
                                    if (val) {
                                      setStartDate(
                                        dayjs.utc(val.format("YYYY-MM-DD")),
                                      );
                                    }
                                  }}
                                  open={openDate}
                                  onOpen={() => setOpenDate(true)}
                                  onClose={() => setOpenDate(false)}
                                  slotProps={{
                                    textField: {
                                      fullWidth: true,
                                      size: "small",
                                      sx: {
                                        flex: 1,
                                        width: "100%",
                                        boxShadow: "0px 2px 4px 0px #D1DEEB33",
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&:hover fieldset": {
                                            border: "0.5px solid #EAF1FA",
                                            borderRadius: "8px",
                                          },
                                          "&.Mui-focused fieldset": {
                                            border: "0.5px solid #2977CC",
                                          },
                                        },
                                      },
                                      onClick: () => setOpenDate(true),
                                    },
                                  }}
                                />
                              </div>
                            </Box>
                          </LocalizationProvider>
                        )}
                        <div
                          style={{
                            marginTop: 20,
                            display: isMobile ? "grid" : "flex",
                            alignItems: "center",
                            justifyContent: isMobile ? "center" : "",
                            gap: 20,
                          }}
                        >
                          <Button
                            disabled={
                              !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              ) ||
                              ((toolId === 4 || toolId === 6) && !startDate)
                            }
                            type="submit"
                            sx={{
                              width: "130px",
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#fff",
                              height: "36px",
                              background:
                                !(
                                  dayjs(startDate).isValid() ||
                                  filterCategoryValue?.length
                                ) ||
                                ((toolId === 4 || toolId === 6) && !startDate)
                                  ? "#BDBDBD"
                                  : "linear-gradient(to right, #2977CC, #1D538F)",
                              cursor: !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              )
                                ? "not-allowed"
                                : "pointer",
                              opacity: !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              )
                                ? 0.7
                                : 1,
                            }}
                            onClick={async () => {
                              setFilterLoading(true);
                              setOpenFilter(false);
                              await dispatch<any>(
                                assignTool({
                                  id: id?.toString() || "",
                                  tool_id: toolId,
                                  date: startDate || null,
                                }),
                              )
                                .then((res: any) => {
                                  setIsFilterApplied(true);
                                  setStartDate(null);
                                  setFilterCategoryValue("");
                                  setToolId(0);
                                  if (
                                    res?.payload?.code === 201 ||
                                    res?.payload?.code === 200
                                  ) {
                                    dispatch<any>(
                                      setToast({
                                        type: "success",
                                        title: "Success",
                                        onClose: () => {},
                                        message: res?.payload?.message,
                                      }),
                                    );
                                  } else {
                                    dispatch<any>(
                                      setToast({
                                        type: "error",
                                        title: "Error",
                                        onClose: () => {},
                                        message: res?.payload?.data?.message,
                                      }),
                                    );
                                  }
                                  dispatch<any>(
                                    getClientsToolsList({
                                      id: id?.toString() || "",
                                      offset: pageNo,
                                      limit,
                                    }),
                                  ).then((res: any) => {
                                    setData(res?.payload?.data);
                                    setTotalRecords(
                                      res?.payload?.total_records,
                                    );
                                  });
                                })
                                .finally(() => setFilterLoading(false));
                              setOpenFilter(false);
                            }}
                          >
                            Apply
                          </Button>
                          <button
                            disabled={
                              !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              )
                            }
                            style={{
                              textAlign: "center",
                              border: "none",
                              fontSize: "14px",
                              fontWeight: 600,
                              background:
                                "linear-gradient(to right, #2977CC, #1D538F)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                              cursor: !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              )
                                ? "not-allowed"
                                : "pointer",
                              opacity: !(
                                dayjs(startDate).isValid() ||
                                filterCategoryValue?.length
                              )
                                ? 0.5
                                : 1,
                            }}
                            onClick={() => {
                              setFilterLoading(true);
                              setFilterCategoryValue("");
                              setStartDate(null);
                              dispatch<any>(
                                assignTool({
                                  id: id?.toString() || "",
                                  tool_id: toolId,
                                  date: startDate || null,
                                }),
                              )
                                .then((res: any) => {
                                  setData(res?.payload?.data?.summary);
                                  setIsFilterApplied(false);
                                })
                                .finally(() => setFilterLoading(false));
                              setOpenFilter(false);
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    )}
                  </Formik>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/**TABLE */}
      <div>
        <CustomTable
          headings={[
            "Service / Tool",
            "Type",
            "Billing",
            "Source",
            "Status",
            "Trial Ends",
            "Assigned On",
            "Action",
          ]}
        >
          {filterLoading ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : (
            data &&
            data?.map((item: any, idx: number) => (
              <TableRow key={item?.id}>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.service_tool || "--"}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.type || "--"}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.billing || "--"}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.source || "--"}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.status?.toLowerCase().includes("trial") && (
                    <span
                      style={{
                        background: "#ff660020",
                        color: "#ff6600",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      Trial
                    </span>
                  )}
                  {item?.status?.toLowerCase().includes("blocked") && (
                    <span
                      style={{
                        background: "#cccccc20",
                        color: "#00000080",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      Blocked
                    </span>
                  )}
                  {item?.status?.toLowerCase().includes("pending") && (
                    <span
                      style={{
                        background: "#ffd00020",
                        color: "#ffd000",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      Pending
                    </span>
                  )}
                  {item?.status?.toLowerCase().includes("active") && (
                    <span
                      style={{
                        background: "#2977CC20",
                        color: "#2977CC",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                      }}
                    >
                      Active
                    </span>
                  )}
                  {item?.status?.toLowerCase().includes("completed") && (
                    <span
                      style={{
                        background: "#3cff0020",
                        color: "#41e600",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      Completed
                    </span>
                  )}
                  {item?.status?.toLowerCase().includes("deactivated") && (
                    <span
                      style={{
                        background: "#ff000020",
                        color: "#ff0000",
                        borderRadius: "18px",
                        fontSize: "14px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                      }}
                    >
                      Deactivated
                    </span>
                  )}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.trial_ends ? (
                    <span>
                      {new Date(item?.trial_ends).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  ) : (
                    "--"
                  )}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.assigned_on ? (
                    <span>
                      {new Date(item?.assigned_on).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>
                  ) : (
                    "--"
                  )}
                </TableCell>
                <TableCell
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                >
                  {item?.source === "Admin" && !item?.is_deactivated ? (
                    <Button
                      onClick={() => {
                        setSelectedId(item?.tool_id);
                        setSelectedToolType(item?.tool_type_id);
                        setIsModalOpen(true);
                      }}
                      sx={{
                        background: "#ff000030",
                        color: "#ff0000",
                        borderRadius: "18px",
                        paddingX: "10px",
                        paddingY: "5px",
                        fontSize: "12px",
                      }}
                    >
                      <RemoveCircle
                        fontSize="small"
                        sx={{ marginRight: 1, color: "#ff0000" }}
                      />{" "}
                      Deactivate
                    </Button>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </CustomTable>
        {data?.length === 0 && !filterLoading && (
          <div
            style={{
              textAlign: "center",
              marginTop: 20,
            }}
          >
            No tools found!
          </div>
        )}
        {/* Pagination */}
        {Math.ceil(totalRecords / limit) > 1 && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
            <CommonPagination
              currentPage={pageNo}
              totalPages={Math.ceil(totalRecords / limit)}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </div>
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="status-modal-title"
        sx={{ zIndex: 99 }}
      >
        <ModalWrapper
          sx={{
            width: isMobile ? "90%" : "45%",
            maxWidth: "498px",
            minHeight: "350px",
            maxHeight: "602px",
            margin: "auto",
            overflow: "hidden",

            p: isMobile ? 2 : 3,
          }}
        >
          <CloseButtonWrapper>
            <CloseButton onClick={() => setIsModalOpen(false)}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // margin: "20px 0",
            }}
          >
            {<ActiveClientIcon />}
          </Box>

          <Content sx={{ textAlign: "center", padding: "0 20px" }}>
            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                marginBottom: "12px",
              }}
            >
              Deactivate Tool
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                textAlign: "center",
                marginBottom: "20px",
                lineHeight: "1.5",
                color: "#6C6F71",
              }}
            >
              Are you sure you want to deactivate this tool?
            </Typography>
          </Content>

          <ButtonWrapper
            sx={{
              display: "flex",
              marginTop: "15px",
              marginBottom: "15px",
              justifyContent: isMobile ? "center" : "space-between",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "10px" : "2px",
            }}
          >
            <CustomButton
              btnTitle="No"
              handleClick={() => setIsModalOpen(false)}
              minwidth={isMobile ? "100%" : "45%"}
              bgColor="#FFF"
              textColor="#2977CC"
              borderColor={"#2977CC"}
              borderWidth={2.3}
              sx={{ fontSize: "18px" }}
            />
            <CustomButton
              btnTitle={"Yes"}
              handleClick={handleDeactivateTool}
              disabled={loading}
              loading={loading}
              minwidth={isMobile ? "100%" : "45%"}
              borderColor={loading ? "transparent" : "#2977CC"}
              sx={{ fontSize: "18px" }}
            />
          </ButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ClientDetail;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  padding: "28px",
  display: "flex",
  gap: "20px ",
});

// Profile Image
const ProfileImage = styled("img")({
  objectFit: "cover",
  height: "86px",
  width: "86px",
  borderRadius: "50%",
});

// Details container
const DetailsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "10px",
  flex: 1,
  flexWrap: "wrap",
});

// Row
const Row = styled(Box)({
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  alignItems: "center",
});

// Divider block
const DividerBlock = styled(Box)({
  borderRight: "1px solid #6C6F7129",
  paddingRight: "20px",
});
export const NameText = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
  color: "#010407",
});

// Section Labels (e.g., Email Address, Phone Number)
export const LabelText = styled(Typography)({
  fontSize: "18px",
  fontWeight: 500,
  color: "#01060B",
});

// Values (e.g., johndoe@gmail.com, +1 number)
export const ValueText = styled(Typography)({
  fontSize: "20px",
  color: "#6C6F71",
});
